// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let Spinner = require("../../../uikit/reason/atoms/Spinner/Spinner.bs.js");
let DialogV5 = require("../../../uikit/reason/molecules/Dialog/DialogV5.bs.js");
let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Form__Label = require("../../../uikit/reason/atoms/Form/Form__Label.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let RadioButtonNew = require("../../../uikit/reason/atoms/Form/RadioButtonNew.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let PropertiesPageRelayFilters = require("./PropertiesPageRelayFilters.bs.js");
let PropertiesPageRelayQueryParams = require("./PropertiesPageRelayQueryParams.bs.js");

function PropertiesPageRelayFiltersMobileMenu(props) {
  let refetch = props.refetch;
  let onClose = props.onClose;
  let match = PropertiesPageRelayQueryParams.use();
  let params = match[0];
  let rentalMode = params.rentalMode;
  return JsxRuntime.jsx(DialogV5.make, {
    isOpen: props.isOpen,
    ariaLabel: "Edit Filters",
    onDismiss: () => onClose(),
    size: "FullScreen",
    showCloseButton: false,
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("h3", {
                children: "Edit Filters",
                className: "text-center font-semibold text-2xl text-zinc-800"
              }),
              JsxRuntime.jsx("button", {
                children: JsxRuntime.jsx(IconV5.make, {
                  icon: "cancel",
                  size: 18,
                  className: "text-gray-500"
                }),
                className: "p-5 cursor-pointer focus:outline-none",
                onClick: param => onClose()
              })
            ],
            className: "flex justify-between items-center"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(Form__Label.make, {
                    labelText: "For Sale or rent"
                  }),
                  JsxRuntime.jsxs(RadioButtonNew.RadioButtonGroup.make, {
                    children: [
                      JsxRuntime.jsx(RadioButtonNew.make, {
                        label: "For Sale",
                        name: "search-type",
                        id: "search-type-for-sale",
                        onChange: param => refetch(undefined, undefined, undefined, p => {
                          let newrecord = {...PropertiesPageRelayQueryParams.preserveRelevantParamsWhenSwitchingModes(p)};
                          newrecord.rentalMode = false;
                          return newrecord;
                        }),
                        checked: !rentalMode
                      }),
                      JsxRuntime.jsx(RadioButtonNew.make, {
                        label: "For Rent",
                        name: "search-type",
                        id: "search-type-rental",
                        onChange: param => refetch(undefined, undefined, undefined, p => {
                          let newrecord = {...PropertiesPageRelayQueryParams.preserveRelevantParamsWhenSwitchingModes(p)};
                          newrecord.rentalMode = true;
                          return newrecord;
                        }),
                        checked: rentalMode
                      })
                    ]
                  })
                ]
              }),
              JsxRuntime.jsx(PropertiesPageRelayFilters.SortOrder.make, {
                refetch: refetch
              }),
              JsxRuntime.jsx(PropertiesPageRelayFilters.MinPrice.make, {
                refetch: refetch
              }),
              JsxRuntime.jsx(PropertiesPageRelayFilters.MaxPrice.make, {
                refetch: refetch
              }),
              JsxRuntime.jsx(PropertiesPageRelayFilters.AreasItem.make, {
                selectedAreaIds: Stdlib_Option.getOr(params.areaIds, []),
                selectedAreas: props.selectedAreas,
                defaultAreas: props.defaultAreas,
                setSelectedAreas: props.setSelectedAreas,
                refetch: refetch
              }),
              JsxRuntime.jsx(PropertiesPageRelayFilters.PropertyTypes.make, {
                mobileMenu: true,
                rentalMode: rentalMode,
                refetch: refetch
              }),
              JsxRuntime.jsx(PropertiesPageRelayFilters.MinBeds.make, {
                refetch: refetch
              }),
              JsxRuntime.jsx(PropertiesPageRelayFilters.MaxBeds.make, {
                refetch: refetch
              }),
              JsxRuntime.jsx(PropertiesPageRelayFilters.MlsStatus.make, {
                refetch: refetch
              }),
              JsxRuntime.jsx(PropertiesPageRelayFilters.Keywords.make, {
                refetch: refetch
              }),
              JsxRuntime.jsx(PropertiesPageRelayFilters.TANStatuses.make, {
                rentalMode: rentalMode,
                refetch: refetch
              })
            ],
            className: "flex flex-col gap-8"
          }),
          JsxRuntime.jsx(DialogV5.ActionBar.make, {
            children: props.isRefetching ? JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                onClick: param => onClose(),
                disabled: false,
                children: JsxRuntime.jsx(Spinner.make, {
                  size: 18,
                  stroke: "white"
                })
              }) : JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                onClick: param => onClose(),
                children: `Show ` + props.totalCount.toString() + ` results`
              })
          })
        ],
        className: "flex-1 flex flex-col gap-6 pb-24"
      }),
      className: "min-h-screen flex flex-col"
    })
  });
}

let make = PropertiesPageRelayFiltersMobileMenu;

exports.make = make;
/* IconV5 Not a pure module */
